import React from "react";
import PropTypes from "prop-types";
import { H2 } from "components/core/Typography";
import Container from "components/core/Page/Container";
import { RelatedContentCard } from "components/molecules";

import "./RelatedContentSection.scss";

export function RelatedContentSection({ heading = "", unitCards = [], background = "light-blue" }) {
	const cards = unitCards;

	return (
		<section className={`related-card-section related-card-section--${background}`}>
			<Container className="related-section-container">
				<div className="related-card__heading">
					<H2 className="card-heading">{heading}</H2>
				</div>
				<div className="related-card__list">
					{cards.map((item) => (
						<RelatedContentCard
							item={item}
							key={item.url}
						/>
					))}
				</div>
			</Container>
		</section>
	);
}

RelatedContentSection.propTypes = {
	heading: PropTypes.string.isRequired,
	unitCards: PropTypes.arrayOf(
		PropTypes.shape({
			category: PropTypes.string.isRequired,
			date: PropTypes.string,
			image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
			content: PropTypes.string,
			url: PropTypes.string.isRequired
		})
	).isRequired,
	background: PropTypes.oneOf(["white", "light-blue"])
};

export default RelatedContentSection;
